module.exports = __webpack_public_path__ + "h5/img/vip2.70a64e4b.png";